import { makeAutoObservable, runInAction } from 'mobx';
import goxApi from 'api/gox-api';
import AlertStore from './Alert';
import Ride from './Ride';

class Rides {

  list = [];
  storage = {};
  active = null;

  constructor() {
    makeAutoObservable(this);
  }

  show(id) {
    return this.storage[id] ?? null;
  }

  select(id) {
    this.active = id;
  }

  async fetch() {
    try {
      const { rides } = await goxApi.ridesActive();
      runInAction(() => {
        this.list = rides.map(ride => ride.id);

        if (!this.active) {
          this.active = this.list?.[0];
        } else {
          const selected = this.list.find(id => id === this.active);
          this.active = selected ?? this.list?.[0];
        }

        rides?.forEach(ride => {
          this.storage[ride.id] = new Ride(ride);
        });
      })
      
    } catch (err) {
      // AlertStore.add(err.message);
    }
  }

  async start(id, planId) {
    try {
      await goxApi.rideStart(id, planId);
    } catch (err) {
      AlertStore.add(err.message);
    }
  }

  async complete(id) {
    await this.show(id)?.complete();
    runInAction(() => {
      const index = this.list.findIndex(item => item === id);
      if (index > -1) {
        this.list?.splice(index, 1);
        delete this.storage[id];
      }
      if (this.active === id) {
        this.active = this.list[0] ?? null;
      }
    });
    AlertStore.add('Ride has been succesfully completed', 'success');
  }
   
}

const RidesStore = new Rides();
export default RidesStore;
